<template>

    <TemplateBasic 
      v-bind:breadcrumb="breadcrumb"
      v-bind:permission="permission">

      <div 
        class="row form-group">

        <div class="col">
        </div>

        <AppSearch 
          ref="pageSearch"
          class="col-md-4"
          v-on:search-data-change="loadInvoice" />
        
      </div>

      <AppFilter 
        ref="carparkFilter" 
        filterKey="carparkID"
        v-on:filter-data-change="onFilterCarparkChange" />

      <AppFilter 
        ref="licenseFilter" 
        filterKey="licenseID"
        v-on:filter-data-change="onFilterLicenseChange" />
      
      <!--
      <h3 v-show="pageShow">Refundable Deposit:</h3>
      <h3 v-show="pageShow">{{refundableDeposit}}</h3>
      <br>

      <h3 v-show="pageShow">Outstanding Balance:</h3>
      <h3 v-show="pageShow">{{outstandingBalance}}</h3>
      <br>
      -->

      <button v-show="pageShow" v-on:click="onCSVButtonClick" type="button" class="btn btn-warning mb-1">
        Export CSV
      </button>

      <AppTable 
        ref="pageTableInvoice" 
        v-bind:tableIdSuffix="'INVOICE'"
        v-bind:tableParameter="PARAM_INV"
        v-on:table-data-click="onTableDataClick" 
        v-on:table-page-change="onInvoiceTablePageChange" />

      <TemplateFeedback class="m-t" ref="pageInvoiceFeedback" />

      <AppTable 
        ref="pageTableDN" 
        v-bind:tableIdSuffix="'DN'"
        v-bind:tableParameter="PARAM_DN"
        v-on:table-data-click="onTableDataClick" 
        v-on:table-page-change="onDNTablePageChange" />

      <TemplateFeedback class="m-t" ref="pageDNFeedback" />

      <AppTable 
        ref="pageTableCN" 
        v-bind:tableIdSuffix="'CN'"
        v-bind:tableParameter="PARAM_CN"
        v-on:table-data-click="onTableDataClick" 
        v-on:table-page-change="onCNTablePageChange" />

      <TemplateFeedback class="m-t" ref="pageCNFeedback" />

      <TemplateFeedback class="m-t" ref="pageFeedback" />

    </TemplateBasic>

</template>

<script>
import TemplateBasic from "@/components/Template/TemplateBasic";
import TemplateButton from "@/components/Template/TemplateButton";
import TemplateFeedback from "@/components/Template/TemplateFeedback";
import AppSearch from "@/components/App/AppSearch";
import AppPaging from "@/components/App/AppPaging";
import AppFilter from "@/components/App/AppFilter";
import AppTable from "@/components/App/AppTable";
import AppAddButton from "@/components/App/AppAddButton";
import AppForm from "@/components/App/AppForm";
import AppModalForm from "@/components/App/AppModalForm";
import validation from "@/components/Utility/Validation"
import helper from "@/components/Utility/Helper"

import PageBillCollectionSelect from "@/components/Page/Collection/PageBillCollectionSelect"


let invoiceNumTableCustom = function(dataResult, dataIndex, dataParameter, parameterIndex) {
  let parameterItem = dataParameter[parameterIndex];
  let dataItem = dataResult[dataIndex];
  if(dataItem['jt-summary']) return;
  
  let billNum = helper.plBillNum(dataItem.creditNum || dataItem.debitNum || dataItem.invoiceNum, dataItem.carparkID, dataItem['type']);
  return `<a href="billPage?invoiceID=${dataItem.id}&type=${dataItem._type}" target="_blank">${billNum}</a>`;
  // return `<a href="${dataItem.path}" target="_blank">${billNum}</a>`;
};
let invoiceAmountTableCustom = function(dataResult, dataIndex, dataParameter, parameterIndex) {
  let parameterItem = dataParameter[parameterIndex];
  let dataItem = dataResult[dataIndex];
  return helper.formatMoney(dataItem[parameterItem.key]);
};

var querystring = require('querystring');
const PARAM_INV = [
  {
    key: '_index',
    index: true,
  },
  {
    key: '_carparkName',
    text: 'Car Park',
    table_custom: function(dataResult, dataIndex, dataParameter, parameterIndex) {
      let parameterItem = dataParameter[parameterIndex];
      let dataItem = dataResult[dataIndex];
      return `<a target="_blank" href="${helper.WEB_URL}/carparkForm?carparkID=${dataItem.carparkID}">${dataItem['_carparkName']}</a>`;
    },
  },
  {
    key: '_licenseNum',
    text: 'Parking License',
    table_custom: function(dataResult, dataIndex, dataParameter, parameterIndex) {
      let parameterItem = dataParameter[parameterIndex];
      let dataItem = dataResult[dataIndex];
      if(!dataItem['licenseID']) {
        return 'N/A';
      }
      if(dataItem['_licenseStatus'] === 'Pending' || dataItem['_licenseStatus'] === 'Pending Initial Payment' || dataItem['_licenseStatus'] === 'Terminated') {
        return helper.plFormPLNum(dataItem._licenseNum, dataItem._carparkNum);
      }
      return `<a target="_blank" href="${helper.WEB_URL}/parkinglicenseView?licenseID=${dataItem.licenseID}">${helper.plFormPLNum(dataItem._licenseNum, dataItem._carparkNum)}</a>`;
    },
  },
  {
    key: '_customerAccount',
    text: 'Account Holder',
    table_custom: function(dataResult, dataIndex, dataParameter, parameterIndex) {
      let parameterItem = dataParameter[parameterIndex];
      let dataItem = dataResult[dataIndex]['_customer'];
      if(!dataItem.id) {
        return '';
      }
      if(dataItem.isCompany) {
        return `<a target="_blank" href="${helper.WEB_URL}/companyForm?customerID=${dataItem.id}">${dataItem.name}</a><br>${dataItem.nationalID}`;
      } else {
        return `<a target="_blank" href="${helper.WEB_URL}/personalForm?customerID=${dataItem.id}">${dataItem.name}</a><br>${dataItem.nationalID}`;
      }
    },
  },
  {
    key: 'createDate',
    text: 'Date Created',
    table_custom: helper.tableCustomDate,
  },
  {
    key: 'invoiceType',
    text: 'INV Type',
    table_custom: function(dataResult, dataIndex, dataParameter, parameterIndex) {
      let parameterItem = dataParameter[parameterIndex];
      let dataItem = dataResult[dataIndex];
      return dataItem['type'];
    }
  },
  {
    key: 'invoiceNum',
    text: 'INV No.',
    table_custom: invoiceNumTableCustom,
  },
  {
    key: 'billingDate',
    text: 'INV Date',
    table_custom: function(dataResult, dataIndex, dataParameter, parameterIndex) {
      let parameterItem = dataParameter[parameterIndex];
      let dataItem = dataResult[dataIndex];
      if(dataItem['_dataRef'] && dataItem['_dataRef']['billingDate']) {
        let billingDate = helper.parseDateTime(dataItem['_dataRef']['billingDate']);
        if(billingDate) {
          return billingDate.format('DD/MM/YYYY');
        }
      }
      return '';
    }
  },
  {
    key: 'type',
    text: 'INV Description',
    table_custom: function(dataResult, dataIndex, dataParameter, parameterIndex) {
      let parameterItem = dataParameter[parameterIndex];
      let dataItem = dataResult[dataIndex];

      if(dataItem['_dataRef'] && dataItem['_dataRef']['description']) {
        return dataItem['_dataRef']['description'];
      }

      if(dataItem['type'] === 'Deposit INV') {
        return 'Refundable Deposit';
      } else if(dataItem['type'] === 'ESTB Fee INV') {
        return 'Establishment Fees';
      } else if(dataItem['type'] === 'INIT Fee INV') {
        if(dataItem['_dataRef'] && dataItem['_dataRef']['commencementDate']) {
          let commencementDate = helper.parseDateTime(dataItem['_dataRef']['commencementDate']);
          if(commencementDate) {
            // Initial Parking Fee (Commencing: 01/10/2016)
            return 'Initial Parking Fee (Commencing: ' + commencementDate.format('DD/MM/YYYY') + ')';
          }
        }
        return 'Initial Parking Fee';
      } else if(dataItem['type'] === 'Monthly Fee INV') {
        if(dataItem['_dataRef'] && dataItem['_dataRef']['billingDate']) {
          let billingDate = helper.parseDateTime(dataItem['_dataRef']['billingDate']);
          if(billingDate) {
            // Monthly Parking Fee 05/2019
            return 'Monthly Parking Fee ' + billingDate.format('MM/YYYY');
          }
        }
        return 'Monthly Parking Fee';
      }

      return '';
    },
  },
  {
    key: 'price',
    text: 'INV Amount (RM)',
    table_custom: invoiceAmountTableCustom,
  },
  {
    key: 'billItemLock',
    text: 'Is Lock',
    table_custom: function(dataResult, dataIndex, dataParameter, parameterIndex) {
      let parameterItem = dataParameter[parameterIndex];
      let dataItem = dataResult[dataIndex];
      return (dataItem['lockDate'] || 0) === 0 ? 'No' : 'Yes';
    },
  },
  {
    key: 'paymentState',
    text: 'Is Paid',
    table_custom: function(dataResult, dataIndex, dataParameter, parameterIndex) {
      let parameterItem = dataParameter[parameterIndex];
      let dataItem = dataResult[dataIndex];
      return (dataItem['paidDate'] || 0) === 0 ? 'No' : 'Yes';
    },
  },
  {
    key: 'billItemVoid',
    text: 'Is VOID',
    table_custom: function(dataResult, dataIndex, dataParameter, parameterIndex) {
      let parameterItem = dataParameter[parameterIndex];
      let dataItem = dataResult[dataIndex];
      return (dataItem['voidDate'] || 0) === 0 ? 'No' : 'Yes';
    },
  }
];

const PARAM_DN = [
  {
    key: '_index',
    index: true,
  },
  {
    key: '_carparkName',
    text: 'Car Park',
    table_custom: function(dataResult, dataIndex, dataParameter, parameterIndex) {
      let parameterItem = dataParameter[parameterIndex];
      let dataItem = dataResult[dataIndex];
      return `<a target="_blank" href="${helper.WEB_URL}/carparkForm?carparkID=${dataItem.carparkID}">${dataItem['_carparkName']}</a>`;
    },
  },
  {
    key: '_licenseNum',
    text: 'Parking License',
    table_custom: function(dataResult, dataIndex, dataParameter, parameterIndex) {
      let parameterItem = dataParameter[parameterIndex];
      let dataItem = dataResult[dataIndex];
      if(!dataItem['licenseID']) {
        return 'N/A';
      }
      if(dataItem['_licenseStatus'] === 'Pending' || dataItem['_licenseStatus'] === 'Pending Initial Payment' || dataItem['_licenseStatus'] === 'Terminated') {
        return helper.plFormPLNum(dataItem._licenseNum, dataItem._carparkNum);
      }
      return `<a target="_blank" href="${helper.WEB_URL}/parkinglicenseView?licenseID=${dataItem.licenseID}">${helper.plFormPLNum(dataItem._licenseNum, dataItem._carparkNum)}</a>`;
    },
  },
  {
    key: '_customerAccount',
    text: 'Account Holder',
    table_custom: function(dataResult, dataIndex, dataParameter, parameterIndex) {
      let parameterItem = dataParameter[parameterIndex];
      let dataItem = dataResult[dataIndex]['_customer'];
      if(!dataItem.id) {
        return '';
      }
      if(dataItem.isCompany) {
        return `<a target="_blank" href="${helper.WEB_URL}/companyForm?customerID=${dataItem.id}">${dataItem.name}</a><br>${dataItem.nationalID}`;
      } else {
        return `<a target="_blank" href="${helper.WEB_URL}/personalForm?customerID=${dataItem.id}">${dataItem.name}</a><br>${dataItem.nationalID}`;
      }
    },
  },
  {
    key: 'createDate',
    text: 'Date Created',
    table_custom: helper.tableCustomDate,
  },
  {
    key: 'invoiceType',
    text: 'DN Type',
    table_custom: function(dataResult, dataIndex, dataParameter, parameterIndex) {
      let parameterItem = dataParameter[parameterIndex];
      let dataItem = dataResult[dataIndex];
      return dataItem['type'];
    }
  },
  {
    key: 'invoiceNum',
    text: 'DN No.',
    table_custom: invoiceNumTableCustom,
  },
  {
    key: 'billingDate',
    text: 'DN Date',
    table_custom: function(dataResult, dataIndex, dataParameter, parameterIndex) {
      let parameterItem = dataParameter[parameterIndex];
      let dataItem = dataResult[dataIndex];
      if(dataItem['_dataRef'] && dataItem['_dataRef']['billingDate']) {
        let billingDate = helper.parseDateTime(dataItem['_dataRef']['billingDate']);
        if(billingDate) {
          return billingDate.format('DD/MM/YYYY');
        }
      }
      return '';
    }
  },
  {
    key: 'type',
    text: 'DN Description',
    table_custom: function(dataResult, dataIndex, dataParameter, parameterIndex) {
      let parameterItem = dataParameter[parameterIndex];
      let dataItem = dataResult[dataIndex];

      if(dataItem['_dataRef'] && dataItem['_dataRef']['description']) {
        return dataItem['_dataRef']['description'];
      }
      
      return '';
    },
  },
  {
    key: 'price',
    text: 'DN Amount (RM)',
    table_custom: function(dataResult, dataIndex, dataParameter, parameterIndex) {
      let parameterItem = dataParameter[parameterIndex];
      let dataItem = dataResult[dataIndex];
      if(dataItem['_dataRef'] && dataItem['_dataRef']['billingDate']) {
        let billingDate = helper.parseDateTime(dataItem['_dataRef']['billingDate']);
        if(billingDate) {
          return billingDate.format('DD/MM/YYYY');
        }
      }
      return '';
    }
  },
  {
    key: 'billItemLock',
    text: 'Is Lock',
    table_custom: function(dataResult, dataIndex, dataParameter, parameterIndex) {
      let parameterItem = dataParameter[parameterIndex];
      let dataItem = dataResult[dataIndex];
      return (dataItem['lockDate'] || 0) === 0 ? 'No' : 'Yes';
    },
  },
  {
    key: 'paymentState',
    text: 'Is Paid',
    table_custom: function(dataResult, dataIndex, dataParameter, parameterIndex) {
      let parameterItem = dataParameter[parameterIndex];
      let dataItem = dataResult[dataIndex];
      return (dataItem['paidDate'] || 0) === 0 ? 'No' : 'Yes';
    },
  },{
    key: 'billItemVoid',
    text: 'Is VOID',
    table_custom: function(dataResult, dataIndex, dataParameter, parameterIndex) {
      let parameterItem = dataParameter[parameterIndex];
      let dataItem = dataResult[dataIndex];
      return (dataItem['voidDate'] || 0) === 0 ? 'No' : 'Yes';
    },
  },
  {
    key: 'billItemDNInvRef',
    text: 'DN INV Ref',
  }
];

const PARAM_CN = [
  {
    key: '_index',
    index: true,
  },
  {
    key: '_carparkName',
    text: 'Car Park',
    table_custom: function(dataResult, dataIndex, dataParameter, parameterIndex) {
      let parameterItem = dataParameter[parameterIndex];
      let dataItem = dataResult[dataIndex];
      return `<a target="_blank" href="${helper.WEB_URL}/carparkForm?carparkID=${dataItem.carparkID}">${dataItem['_carparkName']}</a>`;
    },
  },
  {
    key: '_licenseNum',
    text: 'Parking License',
    table_custom: function(dataResult, dataIndex, dataParameter, parameterIndex) {
      let parameterItem = dataParameter[parameterIndex];
      let dataItem = dataResult[dataIndex];
      if(!dataItem['licenseID']) {
        return 'N/A';
      }
      if(dataItem['_licenseStatus'] === 'Pending' || dataItem['_licenseStatus'] === 'Pending Initial Payment' || dataItem['_licenseStatus'] === 'Terminated') {
        return helper.plFormPLNum(dataItem._licenseNum, dataItem._carparkNum);
      }
      return `<a target="_blank" href="${helper.WEB_URL}/parkinglicenseView?licenseID=${dataItem.licenseID}">${helper.plFormPLNum(dataItem._licenseNum, dataItem._carparkNum)}</a>`;
    },
  },
  {
    key: '_customerAccount',
    text: 'Account Holder',
    table_custom: function(dataResult, dataIndex, dataParameter, parameterIndex) {
      let parameterItem = dataParameter[parameterIndex];
      let dataItem = dataResult[dataIndex]['_customer'];
      if(!dataItem.id) {
        return '';
      }
      if(dataItem.isCompany) {
        return `<a target="_blank" href="${helper.WEB_URL}/companyForm?customerID=${dataItem.id}">${dataItem.name}</a><br>${dataItem.nationalID}`;
      } else {
        return `<a target="_blank" href="${helper.WEB_URL}/personalForm?customerID=${dataItem.id}">${dataItem.name}</a><br>${dataItem.nationalID}`;
      }
    },
  },
  {
    key: 'createDate',
    text: 'Date Created',
    table_custom: helper.tableCustomDate,
  },
  {
    key: 'invoiceType',
    text: 'CN Type',
    table_custom: function(dataResult, dataIndex, dataParameter, parameterIndex) {
      let parameterItem = dataParameter[parameterIndex];
      let dataItem = dataResult[dataIndex];
      return dataItem['type'];
    }
  },
  {
    key: 'invoiceNum',
    text: 'CN No.',
    table_custom: invoiceNumTableCustom,
  },
  {
    key: 'billingDate',
    text: 'CN Date',
    table_custom: function(dataResult, dataIndex, dataParameter, parameterIndex) {
      let parameterItem = dataParameter[parameterIndex];
      let dataItem = dataResult[dataIndex];
      if(dataItem['_dataRef'] && dataItem['_dataRef']['billingDate']) {
        let billingDate = helper.parseDateTime(dataItem['_dataRef']['billingDate']);
        if(billingDate) {
          return billingDate.format('DD/MM/YYYY');
        }
      }
      return '';
    }
  },
  {
    key: 'type',
    text: 'CN Description',
    table_custom: function(dataResult, dataIndex, dataParameter, parameterIndex) {
      let parameterItem = dataParameter[parameterIndex];
      let dataItem = dataResult[dataIndex];

      if(dataItem['_dataRef'] && dataItem['_dataRef']['description']) {
        return dataItem['_dataRef']['description'];
      }

      let description = 'Void ';
      if(dataItem['_dataRef'] && dataItem['_dataRef']['reverseInvoiceNum']) {
        if(dataItem['_dataRef']['reverseInvoiceType']) {
          description += `${helper.plBillNum(dataItem['_dataRef']['reverseInvoiceNum'], dataItem.carparkID, dataItem['_dataRef']['reverseInvoiceType'])}`
        } else {
          description += `${helper.plBillNum(dataItem['_dataRef']['reverseInvoiceNum'], dataItem.carparkID, 'INV')}`
        }
      }
      
      if(dataItem['type'] === 'Rev Deposit CN') {
        description += ' Refundable Deposit';
      } else if(dataItem['type'] === 'Rev ESTB Fee CN') {
        description += ' Establishment Fee';
      } else if(dataItem['type'] === 'Rev INIT Fee CN') {
        description += ' Initial Parking Fee';
        if(dataItem['_dataRef'] && dataItem['_dataRef']['reverseInvoiceCommencementDate']) {
          description += ' (Commencing: ' + helper.parseDateTime(dataItem['_dataRef']['reverseInvoiceCommencementDate']).format('DD/MM/YYYY') + ')'
        }
      } else if(dataItem['type'] === 'Rev Monthly Fee CN') {
        description += ' Monthly Parking Fee';
        if(dataItem['_dataRef'] && dataItem['_dataRef']['reverseInvoiceBillingDate']) {
          description += ' ' + helper.parseDateTime(dataItem['_dataRef']['reverseInvoiceBillingDate']).format('MM/YYYY')
        }
      }

      description += '. ';

      if(dataItem['_dataRef'] && dataItem['_dataRef']['voidReason']) {
        description += dataItem['_dataRef']['voidReason'];
      }

      return description;
    },
  },
  {
    key: 'price',
    text: 'CN Amount (RM)',
    table_custom: invoiceAmountTableCustom,
  },
  {
    key: 'billItemLock',
    text: 'Is Lock',
    table_custom: function(dataResult, dataIndex, dataParameter, parameterIndex) {
      let parameterItem = dataParameter[parameterIndex];
      let dataItem = dataResult[dataIndex];
      return (dataItem['lockDate'] || 0) === 0 ? 'No' : 'Yes';
    },
  },
  {
    key: 'billItemVoid',
    text: 'Is Used',
    table_custom: function(dataResult, dataIndex, dataParameter, parameterIndex) {
      let parameterItem = dataParameter[parameterIndex];
      let dataItem = dataResult[dataIndex];
      return (dataItem['usedDate'] || 0) === 0 ? 'No' : 'Yes';
    },
  },
  {
    key: 'billItemCNInvRef',
    text: 'CN INV Ref',
      table_custom: function(dataResult, dataIndex, dataParameter, parameterIndex) {
        let parameterItem = dataParameter[parameterIndex];
        let dataItem = dataResult[dataIndex];
        if(dataItem['_dataRef'] && dataItem['_dataRef']['reverseInvoiceNum'] && dataItem['_dataRef']['reverseInvoiceType']) {
          return helper.plBillNum(dataItem['_dataRef']['reverseInvoiceNum'], dataItem.carparkID, dataItem['_dataRef']['reverseInvoiceType'])
        }

        return '';
      },
  }
];

export default {
  name: "PageBillCN",
  components: {
    TemplateBasic,
    TemplateButton,
    AppSearch,
    AppPaging,
    AppFilter,
    AppTable,
    AppAddButton,
    AppForm,
    AppModalForm,
    TemplateFeedback,
  },
  data () {
    return {
      permission : null,
      breadcrumb : [
        { name: 'Home', url: helper.WEB_URL },
        { name: 'Bill Management' },
        { name: 'Credit Notes' },
      ],

      PARAM_INV,
      PARAM_DN,
      PARAM_CN,

      pageStaff: [],
      pagePaymentMethod: [],
      pageCarpark: null,
      pageCustomer: null,

      pageBill: null,
      pageInvoice: null,
      pageDebitNote: null,
      pageCreditNote: null,
      pageShow: false,

      refundableDeposit: null,
      outstandingBalance: null,
    }
  },
  mounted() {
    if(!helper.hasViewPermission(this.permission = helper.getPermission(this))) {
      return;
    }
    
    this.$refs['carparkFilter'].formatFilterOptionText = (dataItem) => dataItem.carparkCode ? `${dataItem.carparkCode} - ${dataItem.name}` : dataItem.name;
    this.$refs['licenseFilter'].formatFilterOptionText = option => {
      if(!option.licenseOperatorNum) {
        return 'All Parking Licenses';
      }
      
      let text = helper.plFormPLNum(option.licenseOperatorNum, option.carparkID);
      let customer = option['_customer'];
      text += customer ? ` ${customer.name} (${customer.nationalID})` : '';
      return text;
    };
    this.loadCarpark();
  },
  methods: {
    loadCarpark() {
      let feedbackItem = 'car park data';
      this.$refs['carparkFilter'].setFilterLoading('Loading ' + feedbackItem);

      this.$http
        .get(
          helper.SERVER_URL + '/api2/carpark/',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.pageCarpark = response.data;
          // this.$refs['carparkFilter'].setFilterDataWithValueIfFirstLoad([].concat({name: 'All Car Parks'}, response.data), this.$route.query.carparkID);
          // this.loadCustomer();
          this.setCarparInput();
        })
        .catch(error => {
          this.$refs['carparkFilter'].setFilterError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        });
    },
    setCarparInput() {
      let feedbackItem = 'car park license data'
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);
      this.$http
        .get(
          helper.SERVER_URL + '/api2/license',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.$refs['pageFeedback'].setFeedbackMessage();

          let allParkingLicense = response.data;
          this.pageCarpark = this.pageCarpark.filter(k => {
            return allParkingLicense.find(j => j.carparkID === k.id)
          });

          this.$refs['carparkFilter'].setFilterDataWithValueIfFirstLoad([].concat({name: 'All Car Parks'}, this.pageCarpark), this.$route.query.carparkID);
          this.loadCustomer();
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        });
    },
    loadCustomer() {
      let feedbackItem = 'customer data';
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);

      this.$http
        .get(
          helper.SERVER_URL + '/api2/customer/',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.$refs['pageFeedback'].setFeedbackMessage();
          this.pageCustomer = response.data;
          this.loadLicense();
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        });
    },
    loadLicense() {
      let feedbackItem = 'license data';
      this.$refs['licenseFilter'].setFilterLoading('Loading ' + feedbackItem);

      let url = helper.SERVER_URL + '/api2';
      if(this.$refs['carparkFilter'].filterValue) {
        url += '/carpark/' + this.$refs['carparkFilter'].filterValue;
      }
      url += '/license/';

      this.$http
        .get(
          url,
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.pageLicense = response.data;
          response.data.forEach(k => {
            k['_customer'] = this.pageCustomer.find(j => j.id === k.customerID);
            k['_carpark'] = this.pageCarpark.find(j => j.id === k.carparkID);
          });
          this.$refs['licenseFilter'].setFilterDataWithValueIfFirstLoad([].concat({name: 'All Parking Licenses'}, response.data), this.$route.query.licenseID);

          if(response.data && response.data.length > 0) {
            this.loadData();
          }
        })
        .catch(error => {
          this.$refs['licenseFilter'].setFilterError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        });
    },
    loadData() {
      this.loadCreditNote();
    },
    loadInvoice() {
      let license = this.pageLicense.find(k => helper.compareID(k.id, this.$refs['licenseFilter'].filterValue));

      let feedbackItem = 'invoices';
      this.$refs['pageInvoiceFeedback'].setFeedbackLoading('Loading ' + feedbackItem);

      let url = helper.SERVER_URL + '/api2/invoice?billType=INV';
      if(this.$refs['carparkFilter'].filterValue) {
        url += '&carparkID=' + this.$refs['carparkFilter'].filterValue;
      }
      if(this.$refs['licenseFilter'].filterValue) {
        let license = this.pageLicense.find(k => helper.compareID(k.id, this.$refs['licenseFilter'].filterValue));
        url += '&customerID=' + license.customerID;
      }
      url = helper.appendSearchQuery(url, this.$refs['pageSearch'].searchValue);
      url = helper.appendPagingQuery(url, this.$refs['pageTableInvoice'].getCurrentPage());
      
      this.$http
        .get(
          url,
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response, true, this.$refs['pageTableInvoice']);
          this.$refs['pageInvoiceFeedback'].setFeedbackMessage('');
          this.pageInvoice = response.data;
          if(license) {
            this.pageInvoice = response.data.filter(k => k.customerID === license.customerID && k.carparkID === license.carparkID);
          }
          response.data.forEach(k => {
            k['_type'] = 'invoice';
            k['_customer'] = this.pageCustomer.find(j => j.id === k.customerID) || {};
            k['_carpark'] = this.pageCarpark.find(j => j.id === k.carparkID) || {};
            k['_carparkName'] = k['_carpark'].name || '';
            k['_license'] = this.pageLicense.find(j => j.customerID === k.customerID && j.carparkID === k.carparkID) || {};
            k['licenseID'] = k['_license']['id'];
            k['_licenseNum'] = k['_license']['licenseOperatorNum']
            k['_licenseStatus'] = k['_license']['status']
            k['_carparkNum'] = k['_carpark'].id;
            
            try {
              k['_dataRef'] = JSON.parse(k['dataRef']);
            } catch(e) {              
            }
          });
          this.onLoadAllBillComplete();
        })
        .catch(error => {
          this.$refs['pageInvoiceFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        })
    },
    loadCreditNote() {
      let license = this.pageLicense.find(k => helper.compareID(k.id, this.$refs['licenseFilter'].filterValue));

      let feedbackItem = 'credit notes';
      this.$refs['pageCNFeedback'].setFeedbackLoading('Loading ' + feedbackItem);

      let url = helper.SERVER_URL + '/api2/invoice?billType=CN';
      if(this.$refs['carparkFilter'].filterValue) {
        url += '&carparkID=' + this.$refs['carparkFilter'].filterValue;
      }
      if(this.$refs['licenseFilter'].filterValue) {
        let license = this.pageLicense.find(k => helper.compareID(k.id, this.$refs['licenseFilter'].filterValue));
        url += '&customerID=' + license.customerID;
      }
      url = helper.appendSearchQuery(url, this.$refs['pageSearch'].searchValue);
      url = helper.appendPagingQuery(url, this.$refs['pageTableCN'].getCurrentPage());
      
      this.$http
        .get(
          url,
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response, true, this.$refs['pageTableCN']);
          this.$refs['pageCNFeedback'].setFeedbackMessage('');
          this.pageCreditNote = response.data;
          if(license) {
            this.pageCreditNote = response.data.filter(k => k.customerID === license.customerID && k.carparkID === license.carparkID);
          }
          response.data.forEach(k => {
            k['_type'] = 'creditNote';
            k['_customer'] = this.pageCustomer.find(j => j.id === k.customerID) || {};
            k['_carpark'] = this.pageCarpark.find(j => j.id === k.carparkID) || {};
            k['_carparkName'] = k['_carpark'].name || '';
            k['_license'] = this.pageLicense.find(j => j.customerID === k.customerID && j.carparkID === k.carparkID) || {};
            k['licenseID'] = k['_license']['id'];
            k['_licenseNum'] = k['_license']['licenseOperatorNum']
            k['_licenseStatus'] = k['_license']['status']
            k['_carparkNum'] = k['_carpark'].id;
            
            try {
              k['_dataRef'] = JSON.parse(k['dataRef']);
            } catch(e) {              
            }
          });
          this.onLoadAllBillComplete();
        })
        .catch(error => {
          this.$refs['pageCNFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        })
    },
    loadDebitNote() {
      let license = this.pageLicense.find(k => helper.compareID(k.id, this.$refs['licenseFilter'].filterValue));

      let feedbackItem = 'debit notes';
      this.$refs['pageDNFeedback'].setFeedbackLoading('Loading ' + feedbackItem);

      let url = helper.SERVER_URL + '/api2/invoice?billType=DN';
      // let url = helper.SERVER_URL + '/api2/debitNote?1=1';
      if(this.$refs['carparkFilter'].filterValue) {
        url += '&carparkID=' + this.$refs['carparkFilter'].filterValue;
      }
      if(this.$refs['licenseFilter'].filterValue) {
        let license = this.pageLicense.find(k => helper.compareID(k.id, this.$refs['licenseFilter'].filterValue));
        url += '&customerID=' + license.customerID;
      }
      url = helper.appendSearchQuery(url, this.$refs['pageSearch'].searchValue);
      url = helper.appendPagingQuery(url, this.$refs['pageTableDN'].getCurrentPage());
      
      this.$http
        .get(
          url,
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response, true, this.$refs['pageTableDN']);
          this.$refs['pageDNFeedback'].setFeedbackMessage('');
          this.pageDebitNote = response.data;
          if(license) {
            this.pageDebitNote = response.data.filter(k => k.customerID === license.customerID && k.carparkID === license.carparkID);
          }
          response.data.forEach(k => {
            k['_type'] = 'debitNote';
            k['_customer'] = this.pageCustomer.find(j => j.id === k.customerID) || {};
            k['_carpark'] = this.pageCarpark.find(j => j.id === k.carparkID) || {};
            k['_carparkName'] = k['_carpark'].name || '';
            k['_license'] = this.pageLicense.find(j => j.customerID === k.customerID && j.carparkID === k.carparkID) || {};
            k['licenseID'] = k['_license']['id'];
            k['_licenseNum'] = k['_license']['licenseOperatorNum']
            k['_licenseStatus'] = k['_license']['status']
            k['_carparkNum'] = k['_carpark'].id;
            
            try {
              k['_dataRef'] = JSON.parse(k['dataRef']);
            } catch(e) {              
            }
          });

          this.onLoadAllBillComplete();
        })
        .catch(error => {
          this.$refs['pageDNFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        })
    },

    onLoadAllBillComplete() {
      this.$refs['pageTableInvoice'].setTableData(this.pageInvoice);
      this.$refs['pageTableCN'].setTableData(this.pageCreditNote);
      this.$refs['pageTableDN'].setTableData(this.pageDebitNote);
      this.pageShow = true;
    },

    getUrl(licenseID) {
      let url = helper.SERVER_URL + '/api2';
      if(licenseID) {
        url += '/licenses/' + licenseID;
      }
      url += '/bills';

      return url;
    },

    onFilterCarparkChange(dataIndex) {
      this.pageShow = null;
      this.$refs['licenseFilter'].setFilterData(null);
      this.$refs['pageTableInvoice'].setTableData(this.pageInvoice = null);
      this.$refs['pageTableCN'].setTableData(this.pageCreditNote = null);
      this.$refs['pageTableDN'].setTableData(this.pageDebitNote = null);
      this.loadLicense();
    },
    onFilterLicenseChange(dataIndex) {
      this.$refs['pageFeedback'].setFeedbackError('');
      this.pageSeason = null;
      this.pageParker = null;
      this.pageShow = null;
      this.$refs['pageTableInvoice'].setTableData(this.pageInvoice = null);
      this.$refs['pageTableCN'].setTableData(this.pageCreditNote = null);
      this.$refs['pageTableDN'].setTableData(this.pageDebitNote = null);
      this.loadData();
    },

    onAddButtonClick() {
    },
    onTableDataClick(tableData, tableDataIndex) {
      this.displayOR(tableData[tableDataIndex]);
    },

    onInvoiceTablePageChange() {
      this.$refs['pageTableInvoice'].setTableData(this.pageInvoice = null);
      this.loadInvoice();
    },
    onDNTablePageChange() {
      this.$refs['pageTableDN'].setTableData(this.pageDebitNote = null);
      this.loadDebitNote();
    },
    onCNTablePageChange() {
      this.$refs['pageTableCN'].setTableData(this.pageCreditNote = null);
      this.loadCreditNote();
    },

    displayOR(billItem) {
      // location.href = '/billCollection?carparkID=' + this.$refs['carparkFilter'].filterValue + '&licenseID=' + this.$refs['licenseFilter'].filterValue;
      let temp = [];
      this.pageBill.forEach(k => {
        if(k['selectionID'] === billItem['selectionID']) {
          temp.push(k);
        }
      });

      let temp2 = [];
      temp.forEach(k => {
        if(k['jt-summary']) {
          return;
        }

        let lease = this.pageLease.find(j => j['applicationNum'] === k['applicationNum']);
        k['itemName'] = this.pageSeason.find(j => j.id === lease['seasonID']).name;
        temp2.push(k);
      });

      let temp3 = {};
      temp3['license'] = this.pageLicense.find(k => helper.compareID(k.id, this.$refs['licenseFilter'].filterValue));
      temp3['customer'] = this.pageCustomer.find(k => k.id === temp3['license'].customerID);
      temp3['carpark'] = this.pageCarpark.find(k => helper.compareID(k.id, this.$refs['carparkFilter'].filterValue));
      temp3['carparkFinance'] = this.pageCarparkFinance;
      temp3['carparkAddress'] = this.pageCarparkFinanceAddress;
      temp3['customerAddress'] = this.pageCustomerAddress;
      temp3['bill'] = temp2;
      helper.redirect({ path: helper.WEB_URL + '/billOR', query: temp3});

      // let routeData = this.$router.resolve({path: 'billOR', query: temp3});
      // window.open(routeData.href, '_blank');
    },

    onFormInput(formData, formParameter, input) {
    },
    onCSVButtonClick() {
      let fileSuffix = '';
      let carpark = this.pageCarpark.find(k => helper.compareID(k.id, this.$refs['carparkFilter'].filterValue)) || {name: 'All Car Parks'};
      fileSuffix += ' - ' + this.$refs['carparkFilter'].formatFilterOptionText(carpark);
      let license = this.pageLicense.find(k => helper.compareID(k.id, this.$refs['licenseFilter'].filterValue)) || {};
      fileSuffix += ' - ' + this.$refs['licenseFilter'].formatFilterOptionText(license);
      let currentPage = this.$refs['pageTableCN'].getCurrentPage();
      if(currentPage) {
        fileSuffix += ' - page ' + currentPage;
      }
      printCSV('#jt-tableCN', 'CN' + fileSuffix);
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Page/BillManagement/PageBillCN.vue